import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

export type TransactionFilterValues = {
  time: string;
  transaction: string;
  paymentMethod: string;
  account: string;
  currency: string;
  status: string;
};

const initialState: {
  // biome-ignore lint/suspicious/noExplicitAny: PNX-1749
  transactionList: any[] | undefined;
  transactionFilters: TransactionFilterValues | null;
  transactionSearchValue: string;
} = {
  transactionList: undefined,
  transactionFilters: null,
  transactionSearchValue: "",
};

export const transactionSlice = createSlice({
  name: "transaction",
  initialState: initialState,
  reducers: {
    // biome-ignore lint/suspicious/noExplicitAny: PNX-1749
    setTransactionList: (state, action: PayloadAction<any[] | undefined>) => {
      state.transactionList = action.payload;
    },
    setTransactionFilters: (
      state,
      action: PayloadAction<TransactionFilterValues | null>
    ) => {
      state.transactionFilters = action.payload;
    },
    setTransactionSearchValue: (state, action: PayloadAction<string>) => {
      state.transactionSearchValue = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setTransactionList,
  setTransactionFilters,
  setTransactionSearchValue,
} = transactionSlice.actions;

export default transactionSlice.reducer;
